import { FieldType } from '@indigohive/cogfy-types'
import { GetOperationsResultData } from '@indigohive/cogfy-types/endpoints/getOperations'
import { createElement } from 'react'
import { FIELD_ICONS_BY_TYPE } from '../../../../../../field-types'

type OperationItemProps = {
  operation: GetOperationsResultData
  onClick?: (fieldType: FieldType, fieldOperation?: string, displayName?: string) => void
}

export function FieldsMenuOperationItem (props: OperationItemProps) {
  const { operation, onClick } = props

  const operationName = operation.module ? operation.displayName.split(':')[1] : operation.displayName

  return (
    <li key={operation.name}>
      <a onClick={() => onClick?.(operation.outputType, operation.name, operation.displayName)}>
        {createElement(
          FIELD_ICONS_BY_TYPE[operation.outputType],
          { size: 16 }
        )}
        <span>
          {operationName}
        </span>
        <span className='text-xs opacity-40'>
          {operation.outputType}
        </span>
      </a>
    </li>
  )
}
